import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

type MovieItem = (typeof movies)[number];

export default function MovieCard({ movie }: { movie: MovieItem }) {
  return (
    <Link
      to={`/article/${movie.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-xl aspect-[2/3] bg-background-200">
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 在线观看高清电影`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Rating Badge */}
        <div className="absolute top-3 left-3 bg-background-50/90 backdrop-blur-sm rounded-lg px-2 py-1 flex items-center gap-1">
          <i className="ri-star-fill text-amber-500 text-xs"></i>
          <span className="text-xs font-semibold text-foreground-950">{movie.rating}</span>
        </div>
        {/* Category Badge */}
        <div className="absolute top-3 right-3 bg-primary-500/90 backdrop-blur-sm rounded-lg px-2 py-1">
          <span className="text-xs text-white font-medium">{movie.category}</span>
        </div>
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <div className="text-white">
            <p className="text-xs opacity-80">{movie.year} / {movie.duration}</p>
          </div>
        </div>
      </div>
      <div className="mt-3 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
          {movie.director}
        </p>
      </div>
    </Link>
  );
}